import { Tag, type TagProps, Tooltip } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";

import promotionStore from "../stores/promotionStore";

type DiscountLabelSize = TagProps["size"] | "xxs";

type DiscountLabelProps = {
   sku: string;
   size?: DiscountLabelSize;
};

const DiscountLabel = observer(({ sku, size = "xxs" }: DiscountLabelProps) => {
   const applicablePromotions = promotionStore.getPromotionsBySku(sku);

   // "xxs" is a custom size (for backward compatibility) that we handle separately, because the Tag component does not support it.
   const isXxs = size === "xxs";

   return applicablePromotions.map((promotion) => (
      <div key={promotion.id} className="flex">
         <Tag
            variant="base"
            size={isXxs ? "small" : size}
            className={isXxs ? "text-xxs" : undefined}
            textColor={promotion.applicable ? "var(--color-base-0)" : "var(--color-base-600)"}
            bgColor={promotion.applicable ? "var(--color-promotion)" : "var(--color-base-100)"}
         >
            {promotion.banner}
         </Tag>
         {!promotion.applicable && <Tooltip tooltipText={promotion.inapplicableReason ?? ""} tooltipPosition="top" />}
      </div>
   ));
});

export default DiscountLabel;
